import Flickity from 'flickity';

export default {
  init() {

    // Banner Carousel
    var homeCarousel = document.querySelector('.home-carousel');

    // Progress Bar Variables
    var duration = 5;
    var interval = 10;
    var sliderWrapper = document.querySelector('.home-carousel__wrapper');
    var progressBar = document.querySelector('.home-carousel__timer-bar');
    var isPaused = false;

    sliderWrapper.addEventListener('mouseenter', function() {
      isPaused = true;
    });

    sliderWrapper.addEventListener('mouseleave', function() {
      isPaused = false;
    });

    var percentTime,
    step,
    tick;

    function startProgressbar() {
      resetProgressbar();
      percentTime = 0;
      isPaused = false;
      tick = window.setInterval(increase, interval);
    }

    function increase() {
      if (!isPaused) {
        step = (duration * 1000) / interval;
        percentTime += 100 / step;
        progressBar.style.width = percentTime + "%";
        if (percentTime >= 100) {
          flkty.next();
          startProgressbar();
        }
      }
    }

    function resetProgressbar() {
      progressBar.style.width = 0 + '%';
      clearTimeout(tick);
    }

    if (homeCarousel) {
      // Init Carousel
      var flkty = new Flickity(homeCarousel,{
        cellAlign: 'left',
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
      });

      // Custom Prev/Next Button
      var changeDirection = 'left';
      var prevBtn = document.querySelector('.home-carousel__prev');
      prevBtn.addEventListener( 'click', function() {
        changeDirection = 'right';
        flkty.previous(true);
      });
      var nextBtn = document.querySelector('.home-carousel__next');
      nextBtn.addEventListener( 'click', function() {
        changeDirection = 'left';
        flkty.next(true);
      });

      // Custom Pager
      var slidesLenght = flkty.cells.length;
      var pagerTotal = document.querySelector('.home-carousel__total-page');
      var pagerCurrent = document.querySelector('.home-carousel__current-page');

      pagerTotal.innerHTML = slidesLenght;

      flkty.on( 'change', function( index ) {
        pagerCurrent.innerHTML = index + 1;
        console.log(changeDirection);
        startProgressbar();
      });

      startProgressbar();

    }

    // Instagram Carousel
    var instagramCarousel = document.querySelector('.instagram-pics');

    if(instagramCarousel) {
      new Flickity(instagramCarousel,{
        freeScroll: true,
        contain: true,
        prevNextButtons: false,
        pageDots: false,
      });

      var profileLink = document.querySelector('.instagram-feed__profile');
      var textLink = profileLink.textContent;
      var instagramThumbs = document.querySelectorAll('.instagram-feed__thumb');
      instagramThumbs.forEach(function(el){
        var node = document.createElement('SPAN');
        var textnode = document.createTextNode(textLink);
        node.appendChild(textnode);
        el.appendChild(node);
      });
    }

    // Articles Mobile Carousel
    var articleCarousel = document.querySelector('.featured-articles__grid');
    if(articleCarousel) {
      console.log('need a carousel on mobile')
      new Flickity(articleCarousel,{
        prevNextButtons: false,
        // cellAlign: 'left',
        watchCSS: true
      });
    }

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js